/* followup-suggestion-footer.tsx generated by @compiled/babel-plugin v0.38.1 */
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import "./followup-suggestion-footer.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { useCallback, useEffect, useMemo } from 'react';
import { cx } from '@atlaskit/css';
import SearchIcon from '@atlaskit/icon/core/search';
import { fg } from '@atlaskit/platform-feature-flags';
// eslint-disable-next-line @atlaskit/design-system/no-emotion-primitives -- to be migrated to @atlaskit/primitives/compiled – go/akcss
import { Box, Inline, Pressable } from '@atlaskit/primitives/compiled';
import { usePublish } from '@atlaskit/rovo-triggers';
import { N500 } from '@atlaskit/theme/colors';
import { FollowUpButton } from '@atlassian/conversation-assistant-ui-components';
import { getFrontendExperiment } from '@atlassian/search-experiment';
import { SainAction, useSAINUsageCriteriaMet } from '../../common/controller/analytics';
import { AIModeButton } from '../../v2/common/ui/ai-mode-button';
import { useAIAnswerContext } from '../ai-answer-context';
import { onErrorStateSuggestedQueriesShown, onErrorStateSuggestedQueryClick, onFollowUpSuggestionClick } from '../analytics';
import { AIAnswerFollowUpPill, AIAnswerFollowUpPillText } from './styled';
var stylesCompiled = {
  pillLineHeight: "_vwz47vkz"
};
var styles = {
  button: "_2rko12b0 _11c82smr _189ee4h9 _1dqonqa1 _1h6d1l7x _syazazsu _ca0q12x7 _u5f3utpp _n3td12x7 _19bvutpp _k48p1wq8 _1bto1l2s _o5721q9c _1o9zkb7n _bfhksm61 _irr31dpa _1di6fcek",
  queryText: "_1nmz1hna _y3gn1e5h _299m1dk0",
  whiteSpacePreWrap: "_o5721jtm"
};
export var FollowUpSuggestionFooter = function FollowUpSuggestionFooter() {
  var _useAIAnswerContext = useAIAnswerContext(),
    commonAttributes = _useAIAnswerContext.commonAttributes,
    fireAnalyticsEvent = _useAIAnswerContext.fireAnalyticsEvent,
    setQuery = _useAIAnswerContext.setQuery,
    updateContextCache = _useAIAnswerContext.updateContextCache,
    onClose = _useAIAnswerContext.onClose,
    closeParentDialog = _useAIAnswerContext.closeParentDialog,
    callbacks = _useAIAnswerContext.callbacks,
    showChatFollowUps = _useAIAnswerContext.showChatFollowUps;
  var cloudId = commonAttributes.cloudId,
    followUps = commonAttributes.followUps,
    query = commonAttributes.query,
    answerString = commonAttributes.answerString,
    searchSessionId = commonAttributes.searchSessionId,
    errorStateSuggestedQueries = commonAttributes.errorStateSuggestedQueries;
  var publish = usePublish('ai-mate');
  var _useSAINUsageCriteria = useSAINUsageCriteriaMet(),
    fireSAINUsageEvent = _useSAINUsageCriteria.fireSAINUsageEvent;
  var showNLPFollowUps = followUps.length > 0;
  var _getFrontendExperimen = getFrontendExperiment({
      abTestId: 'kd_sain_show_no_answer_suggestions_exp'
    }),
    serveErrorStateSuggestedQueriesExp = _getFrontendExperimen.serveExperiment;
  var visibleFollowUps = useMemo(function () {
    return showNLPFollowUps ? followUps.slice(0, 2) : serveErrorStateSuggestedQueriesExp ? errorStateSuggestedQueries.slice(0, 2) : [];
  }, [showNLPFollowUps, followUps, errorStateSuggestedQueries, serveErrorStateSuggestedQueriesExp]);
  var showErrorStateSuggestedQueries = visibleFollowUps.length > 0 && !showNLPFollowUps;
  var onPillClick = useCallback(function (followUp) {
    var _callbacks$onFollowUp;
    if (showChatFollowUps) {
      publish({
        type: 'chat-new',
        source: 'sain',
        data: {
          name: followUp.substring(0, 30),
          dialogues: [{
            human_message: {
              content: query
            },
            agent_message: {
              content: answerString
            }
          }],
          prompt: followUp,
          sourceId: searchSessionId
        }
      });
    } else {
      setQuery(followUp);
      updateContextCache({
        fromFollowUp: true
      });
    }
    fireAnalyticsEvent(onFollowUpSuggestionClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      followUpString: followUp,
      destination: 'chat'
    })));
    fireSAINUsageEvent({
      metCriteria: SainAction.FOLLOWUP_CLICKED,
      commonAttributes: commonAttributes
    });
    onClose === null || onClose === void 0 || onClose();
    closeParentDialog === null || closeParentDialog === void 0 || closeParentDialog();
    callbacks === null || callbacks === void 0 || (_callbacks$onFollowUp = callbacks.onFollowUpSuggestionClick) === null || _callbacks$onFollowUp === void 0 || _callbacks$onFollowUp.call(callbacks);
  }, [fireSAINUsageEvent, fireAnalyticsEvent, commonAttributes, onClose, closeParentDialog, callbacks, publish, query, answerString, searchSessionId, setQuery, updateContextCache, showChatFollowUps]);
  var onSuggestedQueryClick = useCallback(function (e, suggestedQuery) {
    e.preventDefault();
    e.stopPropagation();
    setQuery(suggestedQuery);
    fireAnalyticsEvent(onErrorStateSuggestedQueryClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      errorStateSuggestedQuery: suggestedQuery
    })));
    fireSAINUsageEvent({
      metCriteria: SainAction.ERROR_STATE_SUGGESTED_QUERY_CLICKED,
      commonAttributes: commonAttributes
    });
    onClose === null || onClose === void 0 || onClose();
    closeParentDialog === null || closeParentDialog === void 0 || closeParentDialog();
  }, [setQuery, fireAnalyticsEvent, fireSAINUsageEvent, onClose, closeParentDialog, commonAttributes]);
  var onAIModePromptClick = useCallback(function (followUpString) {
    fireSAINUsageEvent({
      metCriteria: SainAction.AI_MODE_FOLLOWUP_CLICKED,
      commonAttributes: commonAttributes
    });
    fireAnalyticsEvent(onFollowUpSuggestionClick(_objectSpread(_objectSpread({}, commonAttributes), {}, {
      followUpString: followUpString,
      destination: 'AI mode'
    })));
  }, [fireSAINUsageEvent, commonAttributes, fireAnalyticsEvent]);
  useEffect(function () {
    if (showErrorStateSuggestedQueries) {
      fireAnalyticsEvent(onErrorStateSuggestedQueriesShown(_objectSpread(_objectSpread({}, commonAttributes), {}, {
        showErrorStateSuggestedQueries: visibleFollowUps
      })));
    }
  }, [showErrorStateSuggestedQueries, fireAnalyticsEvent, commonAttributes, visibleFollowUps]);
  if (fg('rovo_ai_mode_entrypoints_enabled')) {
    return /*#__PURE__*/React.createElement(Inline, {
      space: "space.050",
      alignBlock: "center"
    }, /*#__PURE__*/React.createElement(AIModeButton, {
      aiModePromptLabel: "Get more details",
      aiModeQuery: "More details about ".concat(query),
      cloudId: cloudId,
      onClick: function onClick() {
        return onAIModePromptClick("More details about ".concat(query));
      }
    }), visibleFollowUps.length > 0 && /*#__PURE__*/React.createElement(AIModeButton, {
      aiModePromptLabel: visibleFollowUps[0],
      aiModeQuery: visibleFollowUps[0],
      cloudId: cloudId,
      onClick: function onClick() {
        return onAIModePromptClick(visibleFollowUps[0]);
      }
    }));
  }
  return visibleFollowUps.length > 0 ? visibleFollowUps.map(function (followUp, index) {
    if (showChatFollowUps && !showErrorStateSuggestedQueries) {
      return /*#__PURE__*/React.createElement(Inline, {
        space: "space.050",
        alignBlock: "center",
        key: followUp
      }, /*#__PURE__*/React.createElement(FollowUpButton, {
        onClick: function onClick() {
          return onPillClick(followUp);
        },
        followUpText: followUp,
        followUpIndex: index,
        followUpType: "UNAVAILABLE",
        experienceId: "sain"
      }));
    }
    if (showErrorStateSuggestedQueries) {
      return /*#__PURE__*/React.createElement(Inline, {
        space: "space.050",
        alignBlock: "center",
        key: followUp
      }, /*#__PURE__*/React.createElement(Pressable, {
        xcss: styles.button,
        onClick: function onClick(e) {
          return onSuggestedQueryClick(e, followUp);
        }
      }, /*#__PURE__*/React.createElement("div", {
        className: ax([stylesCompiled.pillLineHeight])
      }, /*#__PURE__*/React.createElement(Inline, {
        space: "space.075",
        alignBlock: "baseline"
      }, /*#__PURE__*/React.createElement(SearchIcon, {
        color: "currentColor",
        label: ""
      }), /*#__PURE__*/React.createElement(Box, {
        xcss: cx(styles.queryText, styles.whiteSpacePreWrap)
      }, followUp)))));
    }
    return /*#__PURE__*/React.createElement(Inline, {
      space: "space.050",
      alignBlock: "center",
      key: followUp
    }, /*#__PURE__*/React.createElement(AIAnswerFollowUpPill, {
      onClick: function onClick() {
        return onPillClick(followUp);
      }
    }, /*#__PURE__*/React.createElement(SearchIcon, {
      label: "",
      LEGACY_size: "small",
      color: "var(--ds-icon, ".concat(N500, ")")
    }), /*#__PURE__*/React.createElement(AIAnswerFollowUpPillText, null, followUp)));
  }) : null;
};